export enum OrderStatus {
  NEW,
  PREPARING,
  DELIVERING,
  DELIVERED,
  PICKED_UP,
  CANCELLED,
  READY,
}

export enum DeliveryType {
  UNSET = -1,
  DELIVERY,
  PICKUP,
}

export enum PaymentMethod {
  UNSET = -1,
  CARD_ON_DELIVERY,
  CASH_ON_DELIVERY,
  ONLINE,
}

export enum PaymentStatus {
  PENDING,
  PAID,
  FAILED,
  REFUNDED,
}

export enum CartModalStage {
  CART,
  CHECKOUT,
  ADD_ADDRESS,
  ORDER_SUCCESS,
  YOOKASSA_PAYMENT,
  PAYMASTER_PAYMENT,
  PROCESSING,
}

export enum DeliveryService {
  CDEK = "cdek",
  DELLIN = "dellin",
  PEK = "pek",
  CUSTOM = "custom",
}

export enum FieldType {
  NOT_SELECTED = -1,
  INPUT,
  SELECT,
  MULTISELECT,
  CHECKBOX,
}

export enum ValueType {
  NOT_SELECTED = -1,
  STRING,
  NUMBER,
  BOOLEAN,
  DATE,
}

export enum Unit {
  NOT_SELECTED = -1,
  GRAM,
  KILOGRAM,
  TON,
  MILLILITER,
  LITER,
  PIECE,
  CENTIMETER,
  METER,
  MINUTE,
  HOUR,
  DAY,
  MONTH,
  YEAR,
  PORTION,
  EMPTY,
}

export enum ClusterTypes {
  FOOD, // 0 - Кафе, рестораны
  FLOWERS, // 1 - Цветы
  DIY, // 2 - Стройматериалы
  CLOTHES, // 3 - Одежда
  FURNITURE, // 4 - Мебель
  DOORS, // 5 - Двери
  DEALER, // 6 - Автосалон, автозапчасти
  OIL, // 7 - Масла
  COSMETICS, // 8 - Косметика
  HOTEL, // 9 - Отель
  BEAUTY_SALON, // 10 - Салон красоты
  MEDICINE, // 11 - Медицина
  PHOTO_STUDIO, // 12 - Фотостудия
  AUTO_PARTS, // 13 - Автозапчасти
}

export enum Status {
  NEW,
  IN_WORK,
  COMPLETED,
  POSTPONED,
  CANCELED,
  DISRUPTED,
  ARCHIVED,
  DELETED,
}

export enum CommonStates {
  LOADING,
}

// === ENUMS ===
export enum RatingValue {
  ONE_STAR,
  TWO_STARS,
  THREE_STARS,
  FOUR_STARS,
  FIVE_STARS,
}

export enum ItemInteractionType {
  FAVORITE,
  VIEW,
  RATING,
}

export enum BonusTransactionType {
  EARNED,
  SPENT,
  CANCELED,
  ADMIN_ADD,
  ADMIN_REMOVE,
}

export enum LegalityScreens {
  PERSONAL_DATA_AGREEMENT, // 0
  PRIVACY_POLICY, // 1
  USER_AGREEMENT, // 2
  COOKIE_POLICY,
}

export enum ItemCardVariant {
  FULL,
  ADDON,
  RECOMMENDATION,
}

export enum EmailStage {
  emailInput,
  codeInput,
  done,
  error,
}

export enum AuthPrimary {
  TELEGRAM,
  EMAIL,
  MAX,
}

export enum LoginStage {
  "getCode",
  "checkCode",
  "done",
  "botLoginProcess",
  "botLoginSuccess",
  "botLoginError",
  "botLink",
}

export enum YooKassaStage {
  WIDGET,
  SUCCESS,
  ERROR,
}

export enum AvailabilityStatus {
  ALWAYS_AVAILABLE, // 0 - всегда доступен (forceStore = false, useStock = false)
  IN_STOCK, // 1 - в наличии (есть остатки / не запрещён)
  OUT_OF_STOCK, // 2 - нет в наличии (нет остатков)
  UNAVAILABLE, // 3 - недоступен (запрещён стоп-листом)
  NO_STORE_SELECTED, // 4 - нет выбранной точки
}

export enum ComplexOrderStatus {
  DRAFT = 0,
  SENT_TO_MANAGER = 1,
  IN_PROGRESS = 2,
  APPROVED = 3,
  CONVERTED = 4,
  ARCHIVED = 5,
}

export enum CategoryFieldType {
  NONE = -1,
  STRING = 0,
  NUMBER = 1,
  TEXT = 2,
  DATE = 3,
  BOOLEAN = 4,
}

export enum PaymasterStage {
  PAYMENT,
  SUCCESS,
  ERROR,
}

export enum Platform {
  WEB = "web",
  ANDROID = "android",
  IOS = "ios",
  ADMIN_WEB = "admin_web",
  ADMIN_ANDROID = "admin_android",
  LANDING = "landing",
}

export enum GoalType {
  CALL_CLICK = "call_click",
  CALL_REQUEST = "call_request",
  ORDER_COMPLETE = "order_complete",
  PROJECT_ORDER = "project_order",
  TECHNICAL_WORK = "technical_work",
  NO_NETWORK = "no_network",
  EMPTY_CATALOG = "empty_catalog",
  DATA_ERROR = "data_error",
  RENDER_ERROR = "render_error",
}

export enum LegalEntityType {
  INDIVIDUAL, // Индивидуальный предприниматель
  LLC, // Общество с ограниченной ответственностью
  JSC, // Акционерное общество
  SOLE, // Самозанятый
  OTHER, // Другое
}

export enum DeliveryStatus {
  CREATED = "CREATED",
  IN_TRANSIT = "IN_TRANSIT",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  DELIVERED = "DELIVERED",
  NOT_DELIVERED = "NOT_DELIVERED",
  RETURNED = "RETURNED",
  CANCELLED = "CANCELLED",
}

export enum ItemVariant {
  DETAILED = "detailed",
  MINIMAL = "minimal",
  FLAT = "flat",
  WIDE = "wide",
}

export enum EntityType {
  CLUSTER = 1,
  STORE = 2,
  CATEGORY = 3,
  ITEM = 4,
  EXECUTOR = 5,
  MOTIVATION = 6,
  PLACE = 7,
  BOOKING = 8,
  ORDER = 9,
  COMPLEX_ORDER = 10,
  PROMO = 11,
  STOCK = 12,
  PRICE = 13,
  STOCK_DOCUMENT = 14,
  PRICE_DOCUMENT = 15,
}

export enum TaskStatus {
  PENDING = 0,
  TAKEN = 1,
  IN_PROGRESS = 2,
  ARRIVED = 3,
  DELIVERED = 4,
  CANCELLED = 5,
}

export enum TaskChangedBy {
  EXECUTOR = 0,
  ADMIN = 1,
  SYSTEM = 2,
}

export enum TaskType {
  DELIVERY = 0,
  SALE = 1,
  SERVICE = 2,
}
